var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-card",
        {
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c("h5", [
                    _vm._v(
                      _vm._s(_vm.$t("apeironGwApp.historicoApoyos.title"))
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "mb-3",
            attrs: {
              placeholder: _vm.$t("apeironGwApp.historicoApoyos.filter"),
            },
            model: {
              value: _vm.filter,
              callback: function ($$v) {
                _vm.filter = $$v
              },
              expression: "filter",
            },
          }),
          _vm._v(" "),
          _c("b-table", {
            staticClass: "text-nowrap",
            attrs: {
              "head-variant": "primary",
              items: _vm.items,
              fields: _vm.translatedFields,
              filter: _vm.filter,
              "per-page": _vm.perPage,
              "current-page": _vm.currentPage,
              striped: "",
              hover: "",
              responsive: "",
              "show-empty": "",
            },
            scopedSlots: _vm._u([
              {
                key: "cell(nombreConvocatoria)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "descripcion",
                        staticStyle: { width: "18rem", height: "2rem" },
                      },
                      [_vm._v(_vm._s(data.value))]
                    ),
                  ]
                },
              },
              {
                key: "cell(fechaInicio)",
                fn: function (data) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatDate(data.value)) +
                        "\n      "
                    ),
                  ]
                },
              },
              {
                key: "cell(fechaTermino)",
                fn: function (data) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatDate(data.value)) +
                        "\n      "
                    ),
                  ]
                },
              },
              {
                key: "cell(estatus)",
                fn: function (data) {
                  return [
                    data.value == _vm.EstadoBeca.VIGENTE
                      ? _c("b-badge", { attrs: { variant: "success" } }, [
                          _vm._v(_vm._s(data.value)),
                        ])
                      : data.value == _vm.EstadoBeca.BAJA
                      ? _c("b-badge", { attrs: { variant: "secondary" } }, [
                          _vm._v(_vm._s(data.value)),
                        ])
                      : data.value == _vm.EstadoBeca.CANCELADA ||
                        data.value == _vm.EstadoBeca.SUSPENDIDA
                      ? _c("b-badge", { attrs: { variant: "danger" } }, [
                          _vm._v(_vm._s(data.value)),
                        ])
                      : _c("b-badge", { attrs: { variant: "info" } }, [
                          _vm._v(_vm._s(data.value)),
                        ]),
                  ]
                },
              },
              {
                key: "cell(justificacion)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "descripcion",
                        staticStyle: { width: "25rem", height: "2rem" },
                      },
                      [_vm._v(_vm._s(data.value))]
                    ),
                  ]
                },
              },
              {
                key: "empty",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "text-center text-muted my-4" },
                      [
                        _c("b-icon", {
                          staticClass: "mb-2",
                          attrs: { icon: "inbox", "font-scale": "2" },
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "mb-0" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("apeironGwApp.historicoApoyos.empty")
                              ) +
                              "\n          "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "emptyfiltered",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "text-center text-muted my-4" },
                      [
                        _c("b-icon", {
                          staticClass: "mb-2",
                          attrs: { icon: "search", "font-scale": "2" },
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "mb-0" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "apeironGwApp.historicoApoyos.emptyFiltered"
                                )
                              ) +
                              "\n          "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _c("b-pagination", {
            staticClass: "mt-3",
            attrs: {
              "total-rows": _vm.items.length,
              "per-page": _vm.perPage,
              align: "center",
            },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }